import { get, over } from "lodash";
import styles from "./toolbox.module.css";
import { useEffect, useRef, useState } from "react";

// Pre-made Toolbox props should extend this interface.
export interface BasicToolboxProps {
  collapsible: boolean;
  showTitleBar?: boolean;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
}

interface ToolboxProps extends BasicToolboxProps {
  title?: string;
  toolboxKey?: string; // To help with re-rendering on content change.
  children: React.ReactNode;
}

export const Toolbox = ({
  title,
  toolboxKey,
  collapsible,
  showTitleBar = true,
  isCollapsed = false,
  onToggleCollapse,
  children,
}: ToolboxProps) => {
  const bodyRef = useRef<HTMLDivElement>(null);

  const getDynamicStyle = () => {
    const style = {
      maxHeight: isCollapsed ? 0 : `${bodyRef.current?.scrollHeight}px`,
      opacity: isCollapsed ? 0 : 1,
      overflow: "hidden",
      transition: "max-height 0.3s ease, opacity 0.3s ease",
    };
    return style;
  };

  const titleBarBorderRadius = isCollapsed ? "5px" : "5px 5px 0 0";
  const titleBarBorderBottom = isCollapsed ? "none" : "1px solid #e0e0e0";

  if (!showTitleBar) {
    return <div className={styles.bodyContent}>{children}</div>;
  }
  return (
    <div key={toolboxKey ?? title} className={styles.container}>
      <div
        ref={bodyRef}
        className={styles.bodyContainer}
        style={getDynamicStyle()}
      >
        <div className={styles.bodyContent}>{children}</div>
      </div>
    </div>
  );
};
